(ns frontend.tenant-customizations
  (:require
   [common.util :as cu]
   [frontend.state.current-session :as session]))

(defn tesi?
  []
  (some #{(cu/str-trim-lcase @session/tenant-name)} ["tesi" "teollisuussijoitus" "tesi survey demo"]))

(defn alj?
  []
  (some #{@session/tenant-name} ["ALJ" "Zapflow" "QA"]))

(defn eq-varainhoito?
  []
  (some #{@session/tenant-name} ["eQ Varainhoito Oy"]))

(defn capman?
  []
  (some #{(cu/str-trim-lcase @session/tenant-name)} ["capman" "demo tenant" "capman portal"]))

(defn diamond-edge-ventures?
  []
  (= "Diamond Edge Ventures" @session/tenant-name))

(defn finindus?
  []
  (some #{@session/tenant-name} ["Finindus" "Zapflow" "Demo tenant"]))

(defn imec-xpand?
  []
  (some #{@session/tenant-name} ["Demo Tenant" "Demo Ventures" "TestReports" "Imec.xpand"]))

(defn demo-tenant?
  []
  (some #{@session/tenant-name} ["Demo Tenant"]))

(defn united-bankers?
  []
  (some #{@session/tenant-name} ["United Bankers"]))

(defn demo-test2-oppo-pipeline?
  [pipeline-id]
  (and (demo-tenant?)
       (= "test2" (:pipeline/name (session/get-entity pipeline-id)))))

(defn capman-is-real-estate-pipeline?
  [pipeline-id]
  (and (capman?)
       (= "Real Estate" (:pipeline/name (get @session/entities pipeline-id)))))

(defn capman-in-real-estate-pipeline?
  []
  (capman-is-real-estate-pipeline? @session/selected-oppo-pipeline))

(defn capman-buyout-pipeline-access?
  []
  (and (capman?)
       (session/access-to-pipeline-with-name? "Buyout")))

(defn f-log?
  []
  (some #{@session/tenant-name} ["F-Log VC"]))

(defn knight-therapeutics?
  []
  (some #{@session/tenant-name} ["Zapflow" "Demo Ventures" "Knight Therapeutics" "QA"]))

(defn panostaja?
  []
  (some #{@session/tenant-name} ["Panostaja" "Zapflow" "Demo Ventures"]))

(defn thuja-capital-management?
  []
  (some #{@session/tenant-name} ["Thuja Capital Management"]))

(defn alj-is-pmo-pipeline?
  [pipeline-id]
  (and (alj?)
       (= "PMO" (:pipeline/name (get @session/entities pipeline-id)))))

(defn voima-ventures?
  []
  (some #{@session/tenant-name} ["Voima Ventures"]))

(defn innovestor?
  []
  (some #{@session/tenant-name} ["Innovestor"]))
